// extracted by mini-css-extract-plugin
export var actionText = "_lx-4";
export var container = "_lx-0";
export var leftSection = "_lx-1";
export var rightSection = "_lx-2";
export var settingsButton = "_lx-6";
export var settingsIcon = "_lx-7";
export var shortcut = "_lx-5";
export var shortcutGroup = "_lx-3";